import * as stylex from '@stylexjs/stylex';
import { styles } from './switch.styles';
interface SwitchProps {
  checked: boolean;
  onChange?: (next: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
  /** Native tooltip. Added for the stage editor's Light row, where the switch is
   *  a hardware command (it runs the fixture) rather than a display preference,
   *  and that difference has to be reachable without a label beside every row. */
  title?: string;
}
export function Switch({
  checked,
  onChange,
  disabled,
  ...rest
}: SwitchProps) {
  return <button type="button" role="switch" aria-checked={checked} disabled={disabled} onClick={() => onChange?.(!checked)} {...rest} {...stylex.props(styles.track, checked && styles.trackOn, disabled && styles.disabled)}>
      <span {...stylex.props(styles.knob, checked && styles.knobOn)} />
    </button>;
}